import script from "./EncounterMetaBar.vue?vue&type=script&setup=true&lang=js"
export * from "./EncounterMetaBar.vue?vue&type=script&setup=true&lang=js"

import "./EncounterMetaBar.vue?vue&type=style&index=0&id=4d1efdc2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d1efdc2"]])

export default __exports__